import {
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DobryAgentFacilityService } from '../../services/dobry-agent-facility.service';
import { DictionaryDobryAgent } from '../../interface/facility-dobry-agent';

@Component({
  selector: 'app-dict-dobry-agent-select',
  templateUrl: './dict-dobry-agent-select.component.html',
  styleUrls: ['./dict-dobry-agent-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DictDobryAgentSelectComponent),
      multi: true,
    },
  ],
})
export class DictDobryAgentSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() label = 'Wybierz';
  @Input() dictType = '';
  @Input() placeholder = 'Wybierz';
  @Input() multiple = false;
  @Input() required = false;

  items: DictionaryDobryAgent[] = [];
  filteredItems: DictionaryDobryAgent[] = [];

  value: number | number[] | null = null;
  disabled = false;

  private onChange: (value: number | number[] | null) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(
    private facilityDobryAgentService: DobryAgentFacilityService,
  ) {}

  ngOnInit(): void {
    this.facilityDobryAgentService.getDictionaryDobryAgentSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((items: DictionaryDobryAgent[]) => {
        this.items = (items ?? [])
          .filter((item) => !item.deleted)
          .filter((item) => !this.dictType || item.type === this.dictType);

        this.filteredItems = this.items;
      });
  }

  writeValue(value: number | number[] | null): void {
    this.value = value;
  }

  registerOnChange(fn: (value: number | number[] | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  changeValue(value: number | number[] | null): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  compareById(a: number | DictionaryDobryAgent, b: number | DictionaryDobryAgent): boolean {
    const first = typeof a === 'object' ? a?.id : a;
    const second = typeof b === 'object' ? b?.id : b;

    return first === second;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
